export default __webpack_public_path__ + "static/media/cancel-blue.2d2abada.svg";